import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { getHealthClassification } from 'features/IRWorkstation/utils/healthScoreUtils';

const PLACEHOLDER = '-';

// A distinct glyph per status; the label is the hover text.
const HEALTH_ICONS = {
	at_risk: WarningAmberOutlinedIcon,
	insufficient: HelpOutlineIcon,
	stable: RemoveCircleOutlineIcon,
	strong: CheckCircleOutlineIcon,
};

const HealthCell = ({ value }) => {
	const classification = getHealthClassification(value);

	if (!classification) {
		return (
			<Tooltip title='No health score calculated'>
				<Box
					component='span'
					data-testid='lp-health-none'
					sx={{ color: 'text.tertiary' }}
				>
					{PLACEHOLDER}
				</Box>
			</Tooltip>
		);
	}

	const Icon = HEALTH_ICONS[value] || HelpOutlineIcon;

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
				width: '100%',
			}}
			data-testid={`lp-health-${value}`}
			aria-label={classification.label}
		>
			<Tooltip
				title={classification.label}
				placement='top'
				slotProps={{
					popper: {
						modifiers: [{ name: 'offset', options: { offset: [0, -10] } }],
					},
				}}
			>
				<Icon sx={{ fontSize: 18, color: classification.color }} />
			</Tooltip>
		</Box>
	);
};

HealthCell.propTypes = {
	value: PropTypes.string,
};

export default HealthCell;
